export const formatNumber = (value: number): string => {
  const MILLION = 1_000_000;
  const THOUSAND = 1_000;

  if (value >= MILLION) {
    return `${(value / MILLION).toFixed(2)}M`;
  }

  if (value >= THOUSAND) {
    return `${(value / THOUSAND).toFixed(2)}K`;
  }

  return `${value.toFixed(2)}`;
};
